<template>
  <v-app class="page">
    <v-container fluid class="fill-height pa-0">
      <v-row class="fill-height">
        <!-- LEFT: Login Form -->
        <v-col
          cols="12"
          md="12"
          class="d-flex justify-center align-center pa-0"
        >
          <v-card class="pa-6" width="100%" max-width="500" flat>
            <!-- Logo -->
            <v-row justify="center" class="mb-6">
              <img :src="logo" height="80" contain />
            </v-row>
            <v-row justify="center" class="px-2 mb-6 text-center justify-cente">
              <v-alert
                type="error"
                dense
                variant="tonal"
                border="bottom"
                class="my-2"
                icon="mdi-alert-outline"
              >
                {{ $t("set_password") }}
              </v-alert>
            </v-row>
            <!-- Form -->
            <v-form @submit.prevent="resetPassword">
              <v-text-field
                v-model="reset_email"
                label="Email"
                type="email"
                prepend-inner-icon="mdi-email"
                required
                variant="solo"
                persistent-placeholder
                disabled
              />
              <v-text-field
                v-model="new_password"
                :type="showPassword ? 'text' : 'password'"
                :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                label="Password"
                prepend-inner-icon="mdi-lock"
                required
                variant="solo"
                persistent-placeholder
                @click:append-inner="showPassword = !showPassword"
              />
              <v-text-field
                v-model="confirm_password"
                :type="showPassword1 ? 'text' : 'password'"
                :append-inner-icon="showPassword1 ? 'mdi-eye' : 'mdi-eye-off'"
                :label="$t('confirm_password')"
                prepend-inner-icon="mdi-lock"
                required
                variant="solo"
                persistent-placeholder
                @click:append-inner="showPassword1 = !showPassword1"
              />

              <v-alert
                v-if="confirm_password"
                :color="passwordMatch ? 'success' : 'error'"
                :icon="passwordMatch ? 'mdi-check' : 'mdi-alert-circle'"
                dense
                variant="tonal"
                class="mb-4"
              >
                {{
                  passwordMatch
                    ? $t("password_match")
                    : $t("password_not_match")
                }}
              </v-alert>

              <!-- Alerts -->
              <v-alert
                v-if="alert.value"
                :type="alert.type"
                dense
                variant="tonal"
                border="bottom"
                class="my-2"
              >
                {{ alert.message }}
              </v-alert>
              <!-- Login Button -->
              <v-row justify="center" class="mt-4">
                <v-btn
                  :loading="loading"
                  color="red-darken-4"
                  dark
                  type="submit"
                  :disabled="
                    !new_password || !confirm_password || !passwordMatch
                  "
                  class="w-100"
                >
                  {{ $t("reset_password") }}
                  <v-icon end class="mx-1">mdi-check-decagram-outline</v-icon>
                </v-btn>
              </v-row>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import determineIpLocation from "../utils/determineIpLocation";
import logoImg from "@/assets/logo_dark.png";
import bg from "@/assets/login_background0.png";
import postRequest from "../api/postRequest";

export default {
  name: "Login",
  data() {
    return {
      logo: logoImg,
      bgImage: bg,
      showPassword: false,
      login: {
        email: "",
        password: "",
      },
      language: "it",
      selectLanguage: [
        { lang: "Italiano", locale: "it" },
        { lang: "English", locale: "en" },
      ],
      alert: { value: false, message: "", type: "" },
      alert_s: { value: false, message: "" },
      loading: false,
      reset_email: null,
      new_password: null,
      confirm_password: null,
      reset_success: false,
      showPassword1: false,
    };
  },
  computed: {
    passwordMatch() {
      return this.new_password === this.confirm_password;
    },
  },
  watch: {},

  mounted() {},
  created() {
    this.$i18n.locale = "it";
    this.reset_email = this.$route.query.email;
    this.setLanguage();
  },
  methods: {
    async resetPassword() {
      if (!this.reset_email) return;
      this.loading = true;
      postRequest
        .object("/user/reset-password", {
          email: this.reset_email,
          password: this.new_password,
          token: this.$route.query.token,
        })
        .then((res) => {
          if (res.data.success === true) {
            this.alert.type = "success";
            this.alert.message = res.data.message;
            this.alert.value = true;
            this.reset_success = true;
            this.loading = false;
            setTimeout(() => {
              this.$router.push({ path: "/auth" });
              this.reset_success = false;
            }, 5000);
          } else {
            this.alert.message = res.data.message;
            this.alert.type = "error";
            this.alert.value = true;
            this.reset_success = false;
            setTimeout(() => {
              this.alert.value = false;
            }, 3000);
          }
        })
        .catch((err) => {
          if (err) {
            this.loading = false;
            this.alert.type = "error";
            this.alert.value = true;
            this.alert.message =
              err.response.data.message || "Something went wrong";
            setTimeout(() => {
              this.alert.value = false;
            }, 4000);
          }
        });
    },
    setLanguage() {
      determineIpLocation()
        .then((response) => {
          const { country } = response;
          switch (country) {
            case "IT":
              this.language = "it";
              break;
            default:
              this.language = "it";
              break;
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
html,
body,
#app {
  height: 100%;
  margin: 0;
}

.page {
  min-height: 100vh;
}

.bg-image {
  background-size: cover;
  background-position: center center;
  flex: 1;
}
</style>
